/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { CategoryScopeModule } from './category-scope.module';
export { CategoryScopeComponent } from './category-scope.component';